import { PermissionsEnum } from "@/auth/interfaces";
import { sizeTab, a11yProps, useCheckPermissions } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableSolicitudContratoFisico from "../shared/componente/TableSolicitudContratoFisico";

export default function SolicitudContratoFisico() {

  useCheckPermissions(PermissionsEnum.api_view_preventa);
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Solicitud Contrato Físico"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Solicitud'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolicitudContratoFisico />
      </CustomTabPanel>

    </SingleTableBoxScene>

  );


}
